
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as index5An7aatTOnuSSSG7aWuXgyH4HL7IQPieVR3USFiItdQMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/index.vue?macro=true";
import { default as devb8tlD9Bo9niHQsmlZBV8YI2E9g1iOkdthDOG9yoJPM4Meta } from "/opt/atlassian/pipelines/agent/build/app/pages/dev.vue?macro=true";
import { default as listseAqKqZBXpY26nrkO1zkcUr8RWZ09S30PXx31rz8DABgMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/lists.vue?macro=true";
import { default as _91nid_93u2zyqDSJzgyKAQfuUd2zC_xmD5jUOJCB7ktkF_45N8uwAMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/news/[nid].vue?macro=true";
import { default as indexGr5EmWquVh6ZhvCN22rOPJ_EGOJiIVRafQu5ClHnN84Meta } from "/opt/atlassian/pipelines/agent/build/app/pages/bible/index.vue?macro=true";
import { default as _91vids_93xqSR4mbhpJiz4SeWHyCcbvZSICeq1WkWZirTXYYK5n0Meta } from "/opt/atlassian/pipelines/agent/build/app/pages/bible/[vids].vue?macro=true";
import { default as search3fOz_45ei1UhaAqQgMKrNb8XHXZ69gFH3t7vFec3tbPjwMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/bible/search.vue?macro=true";
import { default as _91nid_93TNhOQEVcCB032qMqGT1Rwi2_45XN0m8JTmNKKj9EDA8ZsMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/comment/[nid].vue?macro=true";
import { default as indexch1Oq3oDZbxN1VHlB1zoGq0x_7yvWq8ioyul84pWkyEMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/commentary/index.vue?macro=true";
import { default as read8sTfAejT0jlBHDVBxL_45MdYDmqXTPjaigceTdTpvhDAwMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/list/[name]/read.vue?macro=true";
import { default as viewrQHVo5kNhK7J53f6d1a9OekrG4egA_45n5ja2_pHUdWv0Meta } from "/opt/atlassian/pipelines/agent/build/app/pages/list/[name]/view.vue?macro=true";
import { default as _91bid_93bFgI7DOB495yOe_wnZBrYA6NkDDk9hHh8YOdqg1XGx4Meta } from "/opt/atlassian/pipelines/agent/build/app/pages/scripture-index/[bid].vue?macro=true";
import { default as indexVx9undna5zhbtG6PJDOo_psWh1wjfBaEof4MC7G11o8Meta } from "/opt/atlassian/pipelines/agent/build/app/pages/scripture-index/index.vue?macro=true";
import { default as index9tlObc2Itaop_thbvBw94gXni7ZcP4YV0H7aq0KTcL0Meta } from "/opt/atlassian/pipelines/agent/build/app/pages/commentary/[vids]/index.vue?macro=true";
import { default as _91type_937K_huNMIMl32fOVNOy8IGjSSDq1OxteiHaJHKkkr_fIMeta } from "/opt/atlassian/pipelines/agent/build/app/pages/commentary/[vids]/[type].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/index.vue")
  },
  {
    name: "dev___en",
    path: "/en/dev",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/dev.vue")
  },
  {
    name: "dev___fr",
    path: "/fr/dev",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/dev.vue")
  },
  {
    name: "dev___id",
    path: "/id/dev",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/dev.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/index.vue")
  },
  {
    name: "index___id",
    path: "/id",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/index.vue")
  },
  {
    name: "lists___en",
    path: "/en/lists",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/lists.vue")
  },
  {
    name: "lists___fr",
    path: "/fr/listes",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/lists.vue")
  },
  {
    name: "lists___id",
    path: "/id/daftar",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/lists.vue")
  },
  {
    name: "news-nid___en",
    path: "/en/news/:nid()",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/news/[nid].vue")
  },
  {
    name: "news-nid___fr",
    path: "/fr/nouvelles/:nid()",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/news/[nid].vue")
  },
  {
    name: "news-nid___id",
    path: "/id/berita/:nid()",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/news/[nid].vue")
  },
  {
    name: "bible___en",
    path: "/en/bible",
    meta: {"middleware":["bible"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/bible/index.vue")
  },
  {
    name: "bible___fr",
    path: "/fr/bible",
    meta: {"middleware":["bible"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/bible/index.vue")
  },
  {
    name: "bible___id",
    path: "/id/alkitab",
    meta: {"middleware":["bible"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/bible/index.vue")
  },
  {
    name: "bible-vids___en",
    path: "/en/bible/:vids()",
    meta: { ...(_91vids_93xqSR4mbhpJiz4SeWHyCcbvZSICeq1WkWZirTXYYK5n0Meta || {}), ...{"middleware":["bible"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/bible/[vids].vue")
  },
  {
    name: "bible-vids___fr",
    path: "/fr/bible/:vids()",
    meta: { ...(_91vids_93xqSR4mbhpJiz4SeWHyCcbvZSICeq1WkWZirTXYYK5n0Meta || {}), ...{"middleware":["bible"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/bible/[vids].vue")
  },
  {
    name: "bible-vids___id",
    path: "/id/alkitab/:vids()",
    meta: { ...(_91vids_93xqSR4mbhpJiz4SeWHyCcbvZSICeq1WkWZirTXYYK5n0Meta || {}), ...{"middleware":["bible"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/bible/[vids].vue")
  },
  {
    name: "bible-search___en",
    path: "/en/bible/search",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/bible/search.vue")
  },
  {
    name: "bible-search___fr",
    path: "/fr/bible/recherche",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/bible/search.vue")
  },
  {
    name: "bible-search___id",
    path: "/id/alkitab/cari",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/bible/search.vue")
  },
  {
    name: "comment-nid___en",
    path: "/en/comment/:nid()",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/comment/[nid].vue")
  },
  {
    name: "comment-nid___fr",
    path: "/fr/commentaire/:nid()",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/comment/[nid].vue")
  },
  {
    name: "comment-nid___id",
    path: "/id/tafsir/:nid()",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/comment/[nid].vue")
  },
  {
    name: "commentary___en",
    path: "/en/commentary",
    meta: {"middleware":["commentary"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/commentary/index.vue")
  },
  {
    name: "commentary___fr",
    path: "/fr/commentaires",
    meta: {"middleware":["commentary"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/commentary/index.vue")
  },
  {
    name: "commentary___id",
    path: "/id/tafsiran",
    meta: {"middleware":["commentary"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/commentary/index.vue")
  },
  {
    name: "list-name-read___en",
    path: "/en/list/:name()/read",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/list/[name]/read.vue")
  },
  {
    name: "list-name-read___fr",
    path: "/fr/liste/:name()/lire",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/list/[name]/read.vue")
  },
  {
    name: "list-name-read___id",
    path: "/id/daftar/:name()/baca",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/list/[name]/read.vue")
  },
  {
    name: "list-name-view___en",
    path: "/en/list/:name()/view",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/list/[name]/view.vue")
  },
  {
    name: "list-name-view___fr",
    path: "/fr/liste/:name()/voir",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/list/[name]/view.vue")
  },
  {
    name: "list-name-view___id",
    path: "/id/daftar/:name()/lihat",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/list/[name]/view.vue")
  },
  {
    name: "scripture-index-bid___en",
    path: "/en/scripture-index/:bid()",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/scripture-index/[bid].vue")
  },
  {
    name: "scripture-index-bid___fr",
    path: "/fr/index-biblique/:bid()",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/scripture-index/[bid].vue")
  },
  {
    name: "scripture-index-bid___id",
    path: "/id/indeks-alkitab/:bid()",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/scripture-index/[bid].vue")
  },
  {
    name: "scripture-index___en",
    path: "/en/scripture-index",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/scripture-index/index.vue")
  },
  {
    name: "scripture-index___fr",
    path: "/fr/index-biblique",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/scripture-index/index.vue")
  },
  {
    name: "scripture-index___id",
    path: "/id/indeks-alkitab",
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/scripture-index/index.vue")
  },
  {
    name: "commentary-vids___en",
    path: "/en/commentary/:vids()",
    meta: {"middleware":["commentary"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/commentary/[vids]/index.vue")
  },
  {
    name: "commentary-vids___fr",
    path: "/fr/commentaires/:vids()",
    meta: {"middleware":["commentary"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/commentary/[vids]/index.vue")
  },
  {
    name: "commentary-vids___id",
    path: "/id/tafsiran/:vids()",
    meta: {"middleware":["commentary"]},
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/commentary/[vids]/index.vue")
  },
  {
    name: "commentary-vids-type___en",
    path: "/en/commentary/:vids()/:type()",
    meta: { ...(_91type_937K_huNMIMl32fOVNOy8IGjSSDq1OxteiHaJHKkkr_fIMeta || {}), ...{"middleware":["commentary"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/commentary/[vids]/[type].vue")
  },
  {
    name: "commentary-vids-type___fr",
    path: "/fr/commentaires/:vids()/:type()",
    meta: { ...(_91type_937K_huNMIMl32fOVNOy8IGjSSDq1OxteiHaJHKkkr_fIMeta || {}), ...{"middleware":["commentary"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/commentary/[vids]/[type].vue")
  },
  {
    name: "commentary-vids-type___id",
    path: "/id/tafsiran/:vids()/:type()",
    meta: { ...(_91type_937K_huNMIMl32fOVNOy8IGjSSDq1OxteiHaJHKkkr_fIMeta || {}), ...{"middleware":["commentary"]} },
    component: () => import("/opt/atlassian/pipelines/agent/build/app/pages/commentary/[vids]/[type].vue")
  }
]